

import { lazy } from "react";
import ProcessControlDashboard from "../Screens/screens-processo/ProcessoDashboard";
import { endPointCaderno, endPointUser, paths } from "./constantes";
// Factory com dependências injetadas
import { RecursoFormContainer } from '../factories/RecursoFormFactory';
import { UnidadeFormContainer as UnidadeForm } from '../factories/UnidadeFormFactory';
// Refatorando para Lazy Loading
const CampoDeVerificacao = lazy(() => import('../Components/processo/CampoDeVerificacaoV2'));
const QrReader = lazy(() => import('../Components/default-components/qr/QrReader'));
const UnidadeMaterial = lazy(() => import('../Components/default-components/forms/UnidadeMaterialPicker'));
const AcessoNaoPermitido = lazy(() => import('../Screens/AcessoNaoPermitido'));
const FormularioForm = lazy(() => import('../Screens/screens-processo/FormularioForm'));
const Home = lazy(() => import('../Screens/Home'));
const Login = lazy(() => import('../Screens/Login'));
const FrequenciaForm = lazy(() => import('../Screens/screens-commons/FrequenciaForm'));
const RegistroForm = lazy(() => import('../Screens/screens-commons/RegistroForm'));
const SetorForm = lazy(() => import('../Screens/screens-commons/SetorForm'));
const TurnoForm = lazy(() => import('../Screens/screens-commons/TurnoForm'));

const TimeForm = lazy(() => import('../Screens/screens-gestao/TimeForm'));
const Times = lazy(() => import('../Screens/screens-gestao/Times'));
const MaterialForm = lazy(() => import('../Screens/screens-suprimentos/MaterialForm'));
const CadernoDeVerificacao = lazy(() => import('../Screens/screens-processo/CadernoDeVerificacao'));
const CadernoDeVerificacaoForm = lazy(() => import('../Screens/screens-processo/CadernoDeVerificacaoForm'));
const CampoDeFormularioForm = lazy(() => import('../Screens/screens-caderno-custom/CampoDeVerificacaoForm'));
const Cadernos = lazy(() => import('../Screens/screens-processo/Cadernos'));
const Formularios = lazy(() => import('../Screens/screens-processo/Formularios'));
const ControleRow = lazy(() => import('../Screens/screens-processo/ControleRow'));
const EspecificacaoPicker = lazy(() => import('../Screens/screens-processo/EspecificacaoPicker'));
const FluxoDeProcessoForm = lazy(() => import("../Screens/screens-processo/FluxoDeProcessoForm"));
const FolhaDeVerificacaoForm = lazy(() => import('../Screens/screens-processo/CadernoDeVerificacaoForm'));
const LimiteDeControlePicker = lazy(() => import('../Screens/screens-processo/LimiteDeControlePicker'));
const LinhaDePlanoDeControleForm = lazy(() => import("../Components/processo/LinhaDePlanoDeControleFormV2.js"));
const OperacaoForm = lazy(() => import("../Screens/screens-processo/OperacaoForm"));
const ParametroForm = lazy(() => import("../Screens/screens-processo/ParametroForm"));
const PlanoDeControleForm = lazy(() => import('../Screens/screens-processo/PlanoDeControleForm'));
const ProcessoForm = lazy(() => import("../Screens/screens-processo/ProcessoForm"));
const RegistroDeCampoChart = lazy(() => import('../Screens/screens-processo/RegistroDeCampoChart'));
const RegraDeCorrecaoForm = lazy(() => import('../Screens/screens-processo/RegraDeCorrecaoForm'));
const EstoqueForm = lazy(() => import('../Screens/screens-suprimentos/EstoqueForm'));
const Estoques = lazy(() => import('../Screens/screens-suprimentos/Estoques'));
const Kardex = lazy(() => import('../Screens/screens-suprimentos/Kardex'));
const RequisicaoMaterialForm = lazy(() => import('../Screens/screens-suprimentos/RequisicaoMaterialForm'));
const RequisicoesMaterial = lazy(() => import('../Screens/screens-suprimentos/RequisicoesMaterial'));
const PlanosDeControle = lazy(() => import("../Screens/screens-processo/PlanosDeControle"));
const ErrorScreen = lazy(() => import("../Screens/errorScreen"))
const OrdenacaoDeFolhas = lazy(() => import("../Screens/screens-processo/OrdenacaoDeFolhas"))
const Fluxos = lazy(() => import("../Screens/screens-processo/Fluxos"));
const FluxosDeProcesso = lazy(() => import("../Screens/screens-processo/FluxosDeProcesso"));
const Operacoes = lazy(() => import("../Screens/screens-processo/Operacoes"));
const Parametros = lazy(() => import("../Screens/screens-processo/ParametrosView"));
const Processos = lazy(() => import("../Screens/screens-processo/Processos"));
const C_E_P = lazy(() => import("../Screens/screens-processo/C-E-P"));
const RegistroDeCampoDashboard = lazy(() => import("../Screens/screens-processo/ReportScreen"));
const Prototipo = lazy(() => import("../Screens/Prototipo"));
const UserMenu = lazy(() => import("../Screens/UserMenu"));
const OrdemDeCorrecaoForm = lazy(() => import('../Screens/screens-processo/OrdemDeCorrecaoForm'));
const OrdensDeCorrecaoList = lazy(() => import('../Screens/screens-processo/OrdemDeCorrecaoList'));
const OrdemDeCorrecaoApontar = lazy(() => import('../Screens/screens-processo/OrdemDeCorrecaoApontar'));
const AcaoForm = lazy(() => import('../Screens/screens-processo/AcaoForm'));
// Novas telas de listagem seguindo o padrão de Fluxos
const Acoes = lazy(() => import('../Screens/screens-processo/Acoes'));
const Recursos = lazy(() => import('../Screens/screens-processo/Recursos'));
const Unidades = lazy(() => import('../Screens/screens-commons/Unidades'));
const Materiais = lazy(() => import('../Screens/screens-suprimentos/Materiais'));
const MaterialConsumptionDashboard = lazy(() => import('../Screens/screens-suprimentos/MaterialConsumptionDashboard'));





export const routesConfig = [

   {
      service: "processo",

      routes: [
         {
            //errorScreen
            configuration: { allowGetLabel: false, path: "/errorScreen" },
            element: (props) => <ErrorScreen {...props} />,
         },
         {
            configuration: { allowGetLabel: true, context: "processo", path: paths.processos, endPoint: endPointCaderno },
            element: (props) => <Processos  {...props} />,
         },
         {
            configuration: { allowGetLabel: true, context: "parametro", path: paths.parametros, endPoint: endPointCaderno },
            element: (props) => <Parametros  {...props} />,
         },
         {
            configuration: { allowGetLabel: true, context: "fluxoDeProcesso", path: paths.operacoes, endPoint: endPointCaderno },
            element: (props) => <Operacoes  {...props} />,
         },
         {
            configuration: { allowGetLabel: false, context: "fluxoDeProcesso", showCadastros: true, path: paths.fluxos, endPoint: endPointCaderno },
            element: (props) => <Fluxos  {...props} />,
         },
         {
            configuration: { allowGetLabel: true, context: "operacao", path: paths.operacaoForm, endPoint: endPointCaderno },
            element: (props) => <OperacaoForm  {...props} />,
         },

         {
            configuration: { allowGetLabel: false, context: "processo", path: paths.processoForm, endPoint: endPointCaderno },
            element: (props) => <ProcessoForm  {...props} />,
         },
         {
            configuration: { allowGetLabel: false, context: "fluxoDeProcesso", showCadastros: true, path: paths.fluxoDeProcessoForm, endPoint: endPointCaderno },
            element: (props) => <FluxoDeProcessoForm  {...props} />,
         },
         {
            configuration: { allowGetLabel: true, context: "planoDeControle", showCadastros: false, path: paths.planoDeControleForm, endPoint: endPointCaderno },
            element: (props) => <PlanoDeControleForm  {...props} />,
         },
         {
            configuration: { allowGetLabel: true, context: "linhaDePlanoDeControle", path: paths.linhaDePlanoDeControleForm, endPoint: endPointCaderno },
            element: (props) => <LinhaDePlanoDeControleForm {...props} />,
         },
         {
            configuration: { allowGetLabel: true, context: "parametro", path: paths.parametroForm, endPoint: endPointCaderno },
            element: (props) => <ParametroForm {...props} />,
         },
         {
            configuration: { allowGetLabel: false, context: "fluxoDeProcesso", showCadastros: true, path: paths.fluxosDeProcesso, endPoint: endPointCaderno },
            element: (props) => <FluxosDeProcesso {...props} />,
         },
         {
            configuration: { allowGetLabel: false, context: "limiteDeControle", showCadastros: true, path: paths.limiteDeControleForm, endPoint: endPointCaderno },
            element: (props) => <LimiteDeControlePicker {...props} />,
         },
         {
            configuration: { allowGetLabel: false, context: "especificacao", showCadastros: true, path: paths.especificacaoForm, endPoint: endPointCaderno },
            element: (props) => <EspecificacaoPicker  {...props} />,
         },

         {
            configuration: { allowGetLabel: false, context: "controle", showCadastros: true, path: paths.controleForm, endPoint: endPointCaderno, },
            element: (props) => <ControleRow  {...props} />,
         },
         {
            configuration: { allowGetLabel: false, context: "planoDeControle", showCadastros: true, path: paths.planosDeControle, endPoint: endPointCaderno },
            element: (props) => <PlanosDeControle {...props} />
         },
         {
            configuration: { allowGetLabel: false, context: "regraDeCorrecao", showCadastros: true, path: paths.regraDeCorrecaoForm, endPoint: endPointCaderno },
            element: (props) => <RegraDeCorrecaoForm {...props} />
         },

         {
            configuration: { allowGetLabel: false, context: "planoDeControle", path: paths.analisePerformanceCp, endPoint: endPointCaderno },
            element: (props) => <ProcessControlDashboard {...props} />
         },
         {
            configuration: { allowGetLabel: false, context: "registroDeCampo", showCadastros: true, path: paths.reporte, endPoint: endPointCaderno },
            element: (props) => <RegistroDeCampoDashboard  {...props} />,
         },
         {
            configuration: { allowGetLabel: false, context: "cadernoDeVerificacao", showCadastros: false, path: paths.formularioForm, endPoint: endPointCaderno },
            element: (props) => <FormularioForm {...props} />
         },
         {
            configuration: { allowGetLabel: false, context: "folhaDeVerificacao", showCadastros: false, path: paths.ordenacaoDeFolhas, endPoint: endPointCaderno },
            element: (props) => <OrdenacaoDeFolhas {...props} />
         },
         {
            configuration: { allowGetLabel: false, context: "registroDeCampo", showCadastros: true, path: paths.registroDeCampoChart, endPoint: endPointCaderno },
            element: (props) => <RegistroDeCampoChart {...props} />
         },
         {
            configuration: { allowGetLabel: false, context: "campoDeVerificacao", showCadastros: true, path: paths.campoDeVerificacao, endPoint: endPointCaderno },
            element: (props) => <CampoDeVerificacao {...props} />
         },
         {
            configuration: { allowGetLabel: false, context: "folhaDeVerificacao", showCadastros: true, path: paths.folhaDeVerificacaoForm, endPoint: endPointCaderno },
            element: (props) => <FolhaDeVerificacaoForm  {...props} />,
         },
         {
            configuration: { allowGetLabel: false, context: "campoDeVerificacao", showCadastros: false, path: paths.campoDeFormularioForm, endPoint: endPointCaderno },
            element: (props) => <CampoDeFormularioForm {...props} />
         },
         {
            configuration: { allowGetLabel: false, context: "cadernoDeVerificacao", showCadastros: false, path: `${paths.cadernoDeVerificacao}/:id`, endPoint: endPointCaderno },
            element: (props) => <CadernoDeVerificacao  {...props} />,
         },
         {
            configuration: { allowGetLabel: false, context: "cadernoDeVerificacao", showCadastros: false, path: paths.cadernoDeVerificacaoForm, endPoint: endPointCaderno },
            element: (props) => <CadernoDeVerificacaoForm  {...props} />,
         },
         {
            configuration: { allowGetLabel: false, context: "cadernos", path: paths.cadernos, endPoint: endPointCaderno },
            element: (props) => <Cadernos {...props} />
         },
         {
            configuration: { allowGetLabel: false, context: "cadernoDeVerificacaco", path: paths.formularios, endPoint: endPointCaderno },
            element: (props) => <Formularios {...props} />
         },
         {
            configuration: { allowGetLabel: false, context: "cadernoDeVerificacaco", path: paths.C_E_P, endPoint: endPointCaderno },
            element: (props) => <C_E_P {...props} />
         },
         {
            configuration: { allowGetLabel: false, context: "prototipo", path: "/prototipo", endPoint: endPointUser },
            element: (props) => <Prototipo {...props} />
         },
         {
            configuration: { allowGetLabel: false, context: "ordemDeCorrecao", showCadastros: false, path: paths.ordensDeCorrecao, endPoint: endPointCaderno },
            element: (props) => <OrdensDeCorrecaoList {...props} />
         },
         {
            configuration: { allowGetLabel: false, context: "ordemDeCorrecao", showCadastros: false, path: paths.ordemDeCorrecaoForm, endPoint: endPointCaderno },
            element: (props) => <OrdemDeCorrecaoForm {...props} />
         },
         {
            configuration: { allowGetLabel: false, context: "ordemDeCorrecao", showCadastros: false, path: paths.ordemDeCorrecaoApontar, endPoint: endPointCaderno },
            element: (props) => <OrdemDeCorrecaoApontar {...props} />
         },
         {
            configuration: { allowGetLabel: false, context: "acao", showCadastros: false, path: paths.acoes, endPoint: endPointCaderno },
            element: (props) => <Acoes {...props} />
         },
         {
            configuration: { allowGetLabel: false, context: "acao", showCadastros: true, path: paths.acaoForm, endPoint: endPointCaderno },
            element: (props) => <AcaoForm {...props} />
         },
         {
            configuration: { allowGetLabel: false, context: "recurso", showCadastros: false, path: paths.recursos, endPoint: endPointCaderno },
            element: (props) => <Recursos {...props} />
         },
         {
            configuration: { allowGetLabel: false, context: "recurso", showCadastros: true, path: paths.recursoForm, endPoint: endPointCaderno },
            element: (props) => <RecursoFormContainer {...props} />
         }





      ],
   },
   {
      service: "suprimentos",
      routes: [
         {
            configuration: { allowGetLabel: false, context: "material", showCadastros: false, path: paths.materiais, endPoint: endPointCaderno },
            element: (props) => <Materiais {...props} />
         },
         {
            configuration: { allowGetLabel: false, context: "material", showCadastros: true, path: paths.materialForm, endPoint: endPointCaderno },
            element: (props) => <MaterialForm context={"material"} {...props} />,
         },
         {
            configuration: { allowGetLabel: false, context: "unidadeMaterial", showCadastros: true, path: paths.unidadeMaterialForm, endPoint: endPointCaderno },
            element: (props) => <UnidadeMaterial context={"unidadeMaterial"}  {...props} />,
         },
         {
            configuration: { allowGetLabel: false, context: "estoque", showCadastros: false, path: paths.estoqueForm, endPoint: endPointCaderno },
            element: (props) => <EstoqueForm context={"estoque"}  {...props} />,
         },
         {
            configuration: { allowGetLabel: false, context: "estoque", showCadastros: false, path: paths.estoques, endPoint: endPointCaderno },
            element: (props) => <Estoques context={"unidadeMaterial"}  {...props} />,
         },
         {
            configuration: { allowGetLabel: false, context: "estoque", showCadastros: false, path: paths.kardex, endPoint: endPointCaderno },
            element: (props) => <Kardex context={"estoque"}  {...props} />,
         },
         {
            configuration: { allowGetLabel: false, context: "requisicaoMaterial", showCadastros: false, path: paths.requisicoesDeMaterial, endPoint: endPointCaderno },
            element: (props) => <RequisicoesMaterial context={"requisicaoMaterial"}  {...props} />,
         },
         {
            configuration: { allowGetLabel: false, context: "requisicaoMaterial", showCadastros: false, path: paths.requisicaoMaterialForm, endPoint: endPointCaderno },
            element: (props) => <RequisicaoMaterialForm context={"requisicaoMaterial"}  {...props} />,
         },
         {
            configuration: { allowGetLabel: false, context: "materialConsumption", showCadastros: false, path: paths.materialConsumptionDashboard, endPoint: endPointCaderno },
            element: (props) => <MaterialConsumptionDashboard {...props} />,
         },




      ],
   },
   {
      service: "commons",
      routes: [
         {
            configuration: { allowGetLabel: false, context: "unidade", showCadastros: false, path: paths.unidades, endPoint: endPointCaderno },
            element: (props) => <Unidades {...props} />
         },
         {
            configuration: { allowGetLabel: false, context: "unidade", showCadastros: true, path: paths.unidadeForm, endPoint: endPointCaderno },
            element: (props) => <UnidadeForm context={"unidade"} showCadastros={true} {...props} />,
         },
         {
            configuration: { allowGetLabel: false, context: "frequencia", showCadastros: true, path: paths.frequenciaForm, endPoint: endPointCaderno },
            element: (props) => <FrequenciaForm  {...props} />,
         },
         {
            configuration: { allowGetLabel: false, context: "registro", showCadastros: false, path: paths.registroForm, endPoint: endPointCaderno },
            element: (props) => <RegistroForm  {...props} />,
         },
         {
            configuration: { allowGetLabel: false, context: "turno", showCadastros: true, path: paths.turnoForm, endPoint: endPointCaderno },
            element: (props) => <TurnoForm  {...props} />,
         },
         {
            configuration: { allowGetLabel: false, context: "setor", showCadastros: true, path: paths.setorForm, endPoint: endPointCaderno },
            element: (props) => <SetorForm  {...props} />,
         },

      ],
   },
   {
      service: "user",
      routes: [
         {
            configuration: { allowGetLabel: false, context: "user", showCadastros: true, path: paths.home, endPoint: endPointUser },
            element: (props) => <Home {...props} />
         },
         {
            configuration: { allowGetLabel: false, context: "qrReader", showCadastros: false, path: paths.qrReader, endPoint: endPointUser },
            element: (props) => <QrReader {...props} />
         },
         {
            configuration: { allowGetLabel: false, context: "user", showCadastros: true, path: paths.loginForm, endPoint: endPointUser },
            element: (props) => <Login {...props} />
         },
         {
            configuration: {
               allowGetLabel: false,
               context: "user", showCadastros: false
               , path: paths.acessoNaoPermitido, endPoint: endPointUser
            },
            element: (props) => <AcessoNaoPermitido {...props} />
         },
         {
            configuration: { allowGetLabel: false, context: "team", showCadastros: false, path: paths.times, endPoint: endPointUser },
            element: (props) => <Times {...props} />
         },
         {
            configuration: { allowGetLabel: false, context: "team", showCadastros: false, path: paths.timeForm, endPoint: endPointUser },
            element: (props) => <TimeForm {...props} />
         },
         {
            configuration: { allowGetLabel: false, context: "user", showCadastros: false, path: paths.menu, endPoint: endPointUser },
            element: (props) => <UserMenu {...props} />
         },
      ]

   },
   {
      service: "caderno",
      routes: [



      ]

   }
]
